import { render, staticRenderFns } from "./EmptyCompany.vue?vue&type=template&id=714cee3e&"
import script from "./EmptyCompany.vue?vue&type=script&lang=js&"
export * from "./EmptyCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports